import type { QueryHookResult } from '@change-corgi/core/react/async';
import { useQuery } from '@change-corgi/core/react/async';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';

import type { VictoriousPetition } from '../../../../shared/api';

import { getVictoriousPetitions } from './api';

type Options = Readonly<{
	petitionSlugOrId?: string;
}>;

type VictoriousPetitionsState = QueryHookResult<
	Readonly<{ petitions: readonly VictoriousPetition[]; parentPetitionId?: string }>
>;
type Result = ModelHookResult<{
	petitionsState: VictoriousPetitionsState;
}>;

export function useVictoriousPetitions({ petitionSlugOrId }: Options): Result {
	const locale = useLocale();
	const countryCode = useCountryCode();
	const utilityContext = useUtilityContext();

	return {
		data: {
			petitionsState: useQuery(
				async () => ({
					...(await getVictoriousPetitions({ petitionSlugOrId, locale, countryCode }, utilityContext)),
				}),
				[petitionSlugOrId, locale, countryCode, utilityContext],
			),
		},
	};
}
